// charCounters.ts
document.addEventListener('DOMContentLoaded', () => {
  // 1) Grab every textarea with the counter behavior
  document.querySelectorAll<HTMLTextAreaElement>('.charCounters-textarea')
      .forEach(textarea => {
        const wrapper   = textarea.closest('.charCounters-wrapper');
        const countSpan = wrapper?.querySelector<HTMLElement>('.charCounters-total');

        if (!countSpan) {
          console.warn('No .charCounters-char found for', textarea);
          return;
        }

        const updateCounter = () => {
          countSpan.textContent = textarea.value.length.toString();
        };
        textarea.addEventListener('input', updateCounter);

        updateCounter();
      });
});
